import React, { useEffect, useState } from "react";
import Link from "components/link";
import { trackNavClick } from "analytics";
import ImageLink from "./image-link";
import BannerImage from "./banner-image";
import SubCategoryItem from "./sub-category-item";
import clsx from "clsx/lite";

const SubCategory = ({ data, activeCategory }) => {
	const [activeIndex, setActiveIndex] = useState(0);
	// Reset sub-category index to 0 when category changes
	useEffect(() => {
		setActiveIndex(0);
	}, [activeCategory]);

	const handleOnClick = (link) => {
		trackNavClick(link.title);
	};

	return (
		<>
			<div role="menu"
				className={clsx("pl-10 pr-20 flex flex-0",
					data.direction === "horizontal" ? "flex-row gap-8" : "flex-col")}>
				{data?.description &&
					<p className="text-secondary pb-3 text-xs">{data?.description}</p>}
				{data.categoryLinks?.map((link, index) => {
					if (link._type === "imageLink") {
						return <ImageLink data={link} key={link._key} />;
					} else if (link._type === "bannerLink") {
						return <BannerImage data={link} key={link._key} />;
					} else {
						return (
							<Link
								to={link.url}
								className={clsx("text-left py-2 whitespace-nowrap", activeIndex === index && "submenu-hover")}
								key={link._key}
								onClick={() => handleOnClick(link)}
								onMouseOver={() => setActiveIndex(index)}
								onFocus={() => setActiveIndex(index)}
								onKeyDown={(e) => e.key === "Enter" && setActiveIndex(index)}
							>
								{link.title}
							</Link>
						);
					}
				})}
			</div>
			{data.direction !== "horizontal" ? <SubCategoryItem data={data} activeIndex={activeIndex} /> : <> </>}
		</>
	);
};

export default SubCategory;